module.exports = __webpack_public_path__ + "img/logo_en.5180f083.png";